/**
 * Allgemeines Bootstrap fuer Javascript.
 */

$(function() {

    var notifier = Esearcher.Ui.Notifier.getInstance();

    // Zeigt Notifications an
    var displayNotifications = function (messages) {

        try {
            Object.keys(messages).forEach(function (key) {
                messages[key].forEach(function (msg) {
                    notifier.notify(msg, key);
                });
            });
        } catch (e) {
            console.log('error while processing message: ');
            console.log(e);
        }
    };

    // Alte Notifications entfernen
    $(document).on('tabChange', function () {
        notifier.clearAll();
    });

    // loadFinish wird bei pageload (unten) und AJAX-reload getriggert.
    $(document).on('loadFinish', function(e, data) {

        if (typeof data === 'object' && typeof data.__messages !== 'undefined') {
            displayNotifications(data.__messages);
        }

        $('input[data-datepicker="true"], input.datepicker').datepicker({dateFormat: 'dd.mm.yy'});

        $('.dataApplier').each(function(idx, el) {

            (new Esearcher.DataApplier()).bindSelectToText($(el), $('#' + $(el).attr(
                    'data-reference-id')));
        });

        (new Esearcher.SearchListControl()).init();
    }).trigger('loadFinish');

    // Errorhandling-Popup bei AJAX-Requests
    $(document).on('blockLoadError', function (e, data) {

        var errorHtmlObj = $('<html />');
        errorHtmlObj.html(data.toString())
                .find('script')
                .remove();

        // auskommentieren, falls Developerbar im Debug-Popup gewuenscht ist.
        errorHtmlObj.find('#debug_head').remove();

        $('<div id="error-dialog" />').html(errorHtmlObj.html()).dialog({
            title: 'An error occured',
            width: '80%',
            close: function () {
                $(this).dialog('destroy').remove();
            }
        }).show();
    });

    /**
     * Fuehrt (nur) die von der aktuellen Seite benoetigten Funktionen aus.
     */
    var initPageLogic = function () {
        var curPage = $('body').attr('data-page');

        if (typeof curPage !== 'undefined') {
            for (var i = 0; i < Esearcher.pages.length; i++) {

                if (Esearcher.pages[i].id === curPage) {
                    Esearcher.pages[i].run.call(Esearcher);
                } else {
                    // nicht benoetigte pages entfernen, fuer garbage collection...
                    Esearcher.pages.splice(i--, 1);
                }
            }
        } else {
            // nicht benoetigte pages entfernen, fuer garbage collection...
            Esearcher.pages = [];
        }
    };

    initPageLogic();

    /**
     * ES3-1661 Firefox-Bugfix for loading the CKEditor in a Bootstrap dialog.
     * Otherwise some form fields are not selectable in popups (e.g. the popup for adding a link).
     *
     * http://stackoverflow.com/questions/14420300/bootstrap-with-ckeditor-equals-problems
     */
    $.fn.modal.Constructor.prototype.enforceFocus = function() {
        modal_this = this;
        $(document).on('shown.bs.modal', function (e) {
            if (modal_this.$element[0] !== e.target && !modal_this.$element.has(e.target).length
                && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select')
                && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text')) {
                modal_this.$element.focus();
            }
        })
    };

});
